<video id="local-cam-video-tag" [class.fullsize]="fullsized" playsinline muted autoplay></video>
